import React from 'react';
import InlineCitation from './InlineCitation';

/**
 * Markdown `a` renderer used WHILE STREAMING (part of STREAMING_COMPONENTS).
 *
 * Module-level and closure-free on purpose: the streaming pass depends on
 * stable component identities so react-markdown reconciles the tree token by
 * token (perf fix #933). The old streaming anchor rendered citations as plain
 * blue links, which then "flipped" into citation chips only when the turn
 * finished — this renders the SAME InlineCitation chip from the first paint.
 *
 * No refs lookup here (references land at the end of the turn): the chip is
 * visually identical from the URL alone (favicon + domain); the final
 * non-streaming pass adds matchedRef (tooltip title/snippet, citation number).
 */
const StreamingAnchor = ({ node, href, children, ...props }: any) => {
  if (href && /^https?:\/\//.test(href)) {
    const childText =
      typeof children === 'string'
        ? children
        : Array.isArray(children) && children.length === 1 && typeof children[0] === 'string'
          ? children[0]
          : '';
    return <InlineCitation linkText={childText || href} linkUrl={href} />;
  }
  // sandbox:/relative/other links keep the plain-anchor fallback during
  // streaming; the final pass attaches the real handlers (e.g. sandbox
  // download).
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" {...props}>
      {children}
    </a>
  );
};

export default StreamingAnchor;
